export function getCountries(): string[] {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const countries = require("../../node_modules/world-countries/countries.json");
    const countriesNames = [];
    for (const country of countries) {
        countriesNames.push(country.translations.spa.common );
    }
    return countriesNames;
}